import getDateAtMidnight from './getDateAtMidnight';

let today: Date;

const getTodayAtMidnight = (): Date => {
    if (today) {
        return today;
    }

    today = getDateAtMidnight(new Date());

    return today;
};

export default getTodayAtMidnight;
